/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable react/no-danger */
/* eslint-disable no-prototype-builtins */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Row, Col, Tooltip } from 'react-bootstrap';
import { MdInfo } from 'react-icons/md';
import { useIntl } from 'react-intl';
import AppLink from '../../shared/components/app-link/AppLink';
import {
  formatDate,
  getConnectingTime,
  formatTimeStringAmPmFormat,
  formatTimeString,
  convertTravelTime,
  formatCurrency,
  getCabinBaggage,
  showSupplier,
  getSupplierName,
  failedResponseForFareRules,
  getNewDate,
  getNumSeats,
  isEmpty,
  getFlightNumbers,
  getEquipment,
  getOperatedBy,
  // getValueFromAppConfig,
} from '../../shared/helper-utils/appUtils';
import {
  DATE_MONTH_VIEW_FORMAT,
  DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
  ONLY_DATE_MONTH_FORMAT,
} from '../../shared/constants/Constants';
import AppButton from '../../shared/components/app-button/AppButton';
import { getFareRulesApi, getMiniFareRulesApi } from '../../api/flightApi';
import AppSidebar from '../../shared/components/app-sidebar/AppSidebar';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import SelectedFlightDetails from '../one-way/SelectedFlightDetails';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import SelectedMultiCityFlightDetails from './SelectedMultiCityFlightDetails';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppFlightLogo from '../../shared/components/app-flight-logo/AppFlightLogo';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import '../one-way/OneWayResultCard.scss';
import { useAppContext } from '../../saas/AppConfigWrapper';
import FareCard, {
  getClassInfoRows,
} from '../../shared/components/fare-card/FareCard';
import FareBreakup from '../../shared/components/fare-card/FareBreakup';

const FLIGHT_INFO = 'flight';
const FARE_RULES = 'fare-rules';
const FARE_BREAKUP = 'fare-breakup';

function IntlMultiCityResultsCard({
  flights,
  onwardFares,
  isAmPmFormat,
  showInvoiceFare,
  selectedFare,
  searchRequest,
  onFareSelection,
  index,
  onSelectForEmail,
  flightsForEmail,
}) {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const { appConfig } = useAppContext();
  const [userSelectedFare, setUserSelectedFare] = useState(onwardFares[0]);
  const [showFlightDetails, setShowFlightDetails] = useState(false);
  const [selectedTab, setSelectedTab] = useState(FLIGHT_INFO);
  const [isOpenFareRulesDialog, setIsOpenFareRulesDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fareRulesHtml, setFareRulesHtml] = useState('');
  const [showFares, setShowFares] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [miniFareRulesHtml, setMiniFareRulesHtml] = useState('');
  const [isOpenMiniFareRulesDialog, setIsOpenMiniFareRulesDialog] =
    useState(false);

  const getJourneys = (origin, destination, dates) => {
    const originArr = origin.split(':');
    const destinationArr = destination.split(':');
    const newDatesArray = [];
    const datesArray = dates.split(':');
    datesArray.forEach((date) => {
      let newdate = `${date.substring(0, 4)}-${date.substring(
        4,
        6,
      )}-${date.substring(6, 8)}`;
      newdate = formatDate(getNewDate(newdate), ONLY_DATE_MONTH_FORMAT);
      newDatesArray.push(newdate);
    });
    const journeyStringArr = new Array(Number(originArr.length))
      .fill(0)
      .map(
        (d, dIndex) =>
          `${originArr[dIndex].split(',')[0]}-${
            destinationArr[dIndex].split(',')[0]
          }(${newDatesArray[dIndex]})`,
      );
    return journeyStringArr.join(', ');
  };

  const getWaterMarkForFare = () => {
    let watermark = '';
    for (let i = 0; i < 100; i++) {
      watermark += `${getUserAgentId()} `;
    }
    return watermark;
  };

  const getYQForTheFare = (fare) => {
    let yq = 0;
    if (fare.othertaxesbreakup && fare.othertaxesbreakup.length > 0) {
      const { othertaxesbreakup } = fare;
      othertaxesbreakup.forEach((tax) => {
        if (tax.taxcode.toLowerCase() === 'adt_yq') {
          yq += tax.taxamount;
        }
      });
    }
    return yq;
  };

  const getK3ForTheFare = (fare) => {
    let yq = 0;
    if (fare.othertaxesbreakup && fare.othertaxesbreakup.length > 0) {
      const { othertaxesbreakup } = fare;
      othertaxesbreakup.forEach((tax) => {
        const isK3 = tax.taxcode.toLowerCase().includes('k3');
        if (isK3) {
          yq += tax.taxamount;
        }
      });
    }
    return yq;
  };

  const getMealForFlight = (fareType) => {
    if (flights[0].islcc === 'false') {
      return 'Free';
    }
    if (
      // fareType.toLowerCase().indexOf('corporate') > -1 ||
      fareType.toLowerCase().indexOf('flexi') > -1
    ) {
      return 'Meals included';
    }
    return 'Chargeable';
  };

  const handleBook = (fare) => {
    onFareSelection(flights, fare);
    setUserSelectedFare(fare);
  };

  const handleFareRulesClick = async () => {
    setIsLoading(true);
    const response = await getFareRulesApi(
      userSelectedFare.nextraflightkey,
      '',
      'international',
    );
    if (
      response &&
      response.wsstatus &&
      response.wsstatus.status === 'OK' &&
      response.wsstatus.statusCode === '200'
    ) {
      setFareRulesHtml(JSON.parse(response.farerules_html)?.html);
    } else if (
      response &&
      response.ApiStatus &&
      response.ApiStatus.Status === 'OK'
    ) {
      if (response.ApiStatus.Result.hasOwnProperty('AllFareRules')) {
        setFareRulesHtml(response.ApiStatus.Result.AllFareRules.Rule);
      } else {
        setFareRulesHtml(response.ApiStatus.Result.Rule);
      }
    }
    setIsLoading(false);
    setIsOpenFareRulesDialog(true);
  };

  const handleOpenFareRules = async () => {
    setIsLoading(true);
    const response = await getFareRulesApi(
      userSelectedFare.nextraflightkey,
      '',
      'international',
    );
    if (
      response &&
      response.wsstatus &&
      response.wsstatus.status === 'OK' &&
      response.wsstatus.statusCode === '200'
    ) {
      if (
        JSON.parse(response.farerules_html) &&
        JSON.parse(response.farerules_html)?.html !== '' &&
        JSON.parse(response.farerules_html)?.html !== 'null'
      ) {
        setFareRulesHtml(JSON.parse(response.farerules_html)?.html);
      } else {
        setFareRulesHtml(failedResponseForFareRules);
      }
    } else if (
      response &&
      response.ApiStatus &&
      response.ApiStatus.Status === 'OK'
    ) {
      if (response.ApiStatus.Result.hasOwnProperty('AllFareRules')) {
        setFareRulesHtml(response.ApiStatus.Result?.AllFareRules.Rule);
      } else if (response.ApiStatus.Result) {
        setFareRulesHtml(response.ApiStatus.Result.Rule);
      } else {
        setFareRulesHtml(failedResponseForFareRules);
      }
    } else {
      setFareRulesHtml(failedResponseForFareRules);
    }
    setIsLoading(false);
    setSelectedTab(FARE_RULES);
  };

  const handleShowMiniFareRules = async (fare) => {
    setIsLoading(true);
    const response = await getMiniFareRulesApi(
      fare.nextraflightkey,
      '',
      'international',
    );
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      const { Result } = response.ApiStatus;
      if (Result && Result !== '') {
        let { list } = Result;
        list = Array.isArray(list) ? list : [list];
        const resheduleRules = list.filter(
          (rule) => rule?.typequalifier?.toLowerCase() === 'change',
        );
        const CancelRule = list.filter(
          (rule) => rule?.typequalifier?.toLowerCase() === 'cancellation',
        );
        const rules = {
          reshedule: resheduleRules || [],
          cancellation: CancelRule || [],
        };
        if (resheduleRules.length > 0 || CancelRule.length > 0) {
          setMiniFareRulesHtml(rules);
          setIsOpenMiniFareRulesDialog(true);
        } else {
          setAlert({
            variant: 'error',
            title: 'Mini Fare Rules',
            description: 'Mini fare rules not available at the moment',
          });
        }
      } else {
        setAlert({
          variant: 'error',
          title: 'Mini Fare Rules',
          description: 'Mini fare rules not available at the moment',
        });
      }
    } else {
      setAlert({
        variant: 'error',
        title: 'Mini Fare Rules',
        description: 'Mini fare rules not available at the moment',
      });
    }
    setIsLoading(false);
  };

  const getTripSeats = (targetFare, flight, tripIndex) => {
    const fareSeats = targetFare?.numseatsavailable?.[tripIndex];
    if (fareSeats) {
      if (Array.isArray(fareSeats)) {
        return fareSeats;
      }
      return [fareSeats];
    }
    if (flight?.flightlegs) {
      return flight.flightlegs.map((leg) => leg.numseatsavailable);
    }
    return [];
  };

  function FlightInfo({ flight, isOnward, fltIndex }) {
    const getTerminal = (city, terminal) => (
      <span style={{ fontSize: '12px', color: '#768391' }}>
        {city}
        {terminal !== '' && terminal !== 'null' && terminal !== '-' && (
          <>-{terminal}</>
        )}
      </span>
    );

    const getStopOverInfo = () => {
      if (flight.flightlegs.length === 1) {
        return (
          <div className="d-flex flex-column">
            <p className="non-stop-seperator " />
            <span className="fs-10">
              {!isEmpty(flight.flightlegs[0].stopoverinfo) &&
              flight.flightlegs[0].stopoverinfo !== 'N' &&
              flight.flightlegs[0].stopoverinfo.length > 1
                ? `stopover at ${flight.flightlegs[0].stopoverinfo}`
                : 'Non Stop'}
            </span>
          </div>
        );
      }
      let stopoverInfo = `${flight.flightlegs.length - 1} ${
        flight.flightlegs.length > 2
          ? formattedMessage('stops')
          : formattedMessage('stop_singular')
      } ${formattedMessage('at')} `;
      flight.flightlegs.forEach((flightLeg, flight_leg_index) => {
        if (flight_leg_index !== flight.flightlegs.length - 1) {
          stopoverInfo += `${flightLeg.destination}, `;
        }
      });
      stopoverInfo = stopoverInfo.slice(0, -2);
      return (
        <div className="d-flex flex-column">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="layover-tooltip">
                <div className="d-flex flex-column fs-10">
                  <span>Change of Planes at</span>
                  {flight.flightlegs.map(
                    (leg, leg_index) =>
                      leg_index !== flight.flightlegs.length - 1 && (
                        <span key={leg.destination}>
                          {leg.destination_name}({leg.destination}) |{' '}
                          {getConnectingTime(
                            leg.arrtime,
                            leg.arrdate,
                            flight.flightlegs[leg_index + 1].deptime,
                            flight.flightlegs[leg_index + 1].depdate,
                          )}{' '}
                          layover
                        </span>
                      ),
                  )}
                </div>
              </Tooltip>
            }
          >
            <div className="cursor-pointer">
              <p className="multi-stop-seperator">
                <span className="layover-pointer" />
              </p>
              <span
                className="fs-10 d-inline-block"
                style={{ marginTop: '7px' }}
              >
                {stopoverInfo}
              </span>
            </div>
          </OverlayTrigger>
        </div>
      );
    };

    return (
      <>
        <div
          style={{ color: '#ccc' }}
          className={`fs-12 fw-500 grey-color ${
            fltIndex === 0 ? 'mb-2' : 'mt-1'
          }`}
        >
          Trip - {fltIndex + 1}
        </div>
        <Row
          className={`spacing-0 flex-1 flight-info_flight-details ${
            isOnward ? 'pb-2' : 'mt-2'
          }`}
          style={{ borderBottom: isOnward ? '1px solid #e9e9e9' : 'none' }}
        >
          <Col
            lg={4}
            md={4}
            sm={4}
            xs={3}
            className="d-flex flex-sm-row flex-column"
          >
            <div className="flight-info_flight-details">
              <div className="d-flex">
                <div className="d-flex me-2 flight-image">
                  <AppFlightLogo
                    carrier={flight.flightlegs[0].carrier.substring(0, 2)}
                    className="vertical-bottom"
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column flight-name">
              <span className="flight-company">
                {flight.flightlegs[0].validatingcarriername}
              </span>
              <span className="fs-10 flight-number">
                {getFlightNumbers(flight, userSelectedFare, false, true)}
              </span>
              {!isEmpty(getSupplierName(userSelectedFare.supplierName)) && (
                <span className="fs-10 supplier-name">
                  {getSupplierName(userSelectedFare.supplierName)}
                </span>
              )}
              {getEquipment(flight, userSelectedFare, false, true) !== '' && (
                <span className="fs-8 fw-300 grey-color">
                  {getEquipment(flight, userSelectedFare, false, true)
                    ?.trim()
                    ?.toUpperCase() === 'BUS' ||
                  getEquipment(flight, userSelectedFare, false, true)
                    ?.trim()
                    ?.toUpperCase() === 'BUS TRANSFER'
                    ? 'Bus Transfer'
                    : `Equipment: ${getEquipment(
                        flight,
                        userSelectedFare,
                        false,
                        true,
                      )}`}
                </span>
              )}
              {getOperatedBy(flight) !== '' && (
                <span className="fs-8 fw-300 grey-color">
                  Operated By:{' '}
                  {getOperatedBy(flight, userSelectedFare, false, true)}
                </span>
              )}
            </div>
          </Col>
          <Col lg={8} md={8} sm={8} xs={9}>
            <Row>
              <Col
                lg={5}
                md={5}
                sm={5}
                xs={5}
                className="d-flex justify-content-start"
              >
                <div className="d-flex flex-column">
                  <span className="title fw-600">
                    {isAmPmFormat
                      ? formatTimeStringAmPmFormat(flight.flightlegs[0].deptime)
                      : formatTimeString(flight.flightlegs[0].deptime)}
                  </span>
                  {getTerminal(
                    flight.flightlegs[0].origin,
                    flight.flightlegs[0].depterminal,
                  )}
                </div>
              </Col>
              <Col
                lg={2}
                md={2}
                sm={2}
                xs={2}
                className="d-flex justify-content-center  px-0"
              >
                <div className="d-flex flex-column text-center">
                  <span className="fs-12 fw-500 grey-color">
                    {convertTravelTime(flight.totaljourneyduration)}
                  </span>
                  {getStopOverInfo()}
                </div>
              </Col>
              <Col
                lg={5}
                md={5}
                sm={5}
                xs={5}
                className="d-flex justify-content-end"
              >
                <div className="d-flex flex-column text-end">
                  <span className="title fw-600">
                    {isAmPmFormat
                      ? formatTimeStringAmPmFormat(
                          flight.flightlegs[flight.flightlegs.length - 1]
                            .arrtime,
                        )
                      : formatTimeString(
                          flight.flightlegs[flight.flightlegs.length - 1]
                            .arrtime,
                        )}
                    {flight.flightlegs[0].depdate !==
                      flight.flightlegs[flight.flightlegs.length - 1]
                        .arrdate && <span className="extra-days">+1</span>}
                  </span>
                  {getTerminal(
                    flight.flightlegs[flight.flightlegs.length - 1].destination,
                    flight.flightlegs[flight.flightlegs.length - 1].arrterminal,
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    );
  }
  const handleSelectForEmail = (fare) => {
    onSelectForEmail(flights, fare);
  };
  const isFareSelectedForEmail = (fare) => {
    if (flightsForEmail.length > 0) {
      const present = flightsForEmail.some(
        (d) => d.fare.nextraflightkey === fare.nextraflightkey,
      );
      if (present) {
        return true;
      }
      return false;
    }
    return false;
  };
  function FareComponent({ fare }) {
    // New fare card with inclusions & penalties (toggle: FareCardWithInclusion
    // in saas/AppConfigWrapper.jsx).
    if (appConfig?.FareCardWithInclusion) {
      return (
        <FareCard
          fare={fare}
          watermark={getWaterMarkForFare()}
          isSelected={fare.nextraflightkey === userSelectedFare.nextraflightkey}
          onSelect={setUserSelectedFare}
          showInvoiceFare={showInvoiceFare}
          fareBreakup={
            <FareBreakup fare={fare} showInvoiceFare={showInvoiceFare} />
          }
          checkinFallback={getCabinBaggage(
            fare.flightBagWeight?.[0]?.[0],
            fare.flightBagUnit?.[0]?.[0],
          )}
          cabinFallback={getCabinBaggage(
            fare.cabinBagweight?.[0]?.[0],
            fare.cabinBagunit?.[0]?.[0],
          )}
          infoRows={[
            ...getClassInfoRows(fare.bookingClass),
            ...(showSupplier()
              ? [
                  {
                    label: 'Supplier',
                    value: getSupplierName(fare.supplierName),
                  },
                ]
              : []),
          ]}
          seatGroups={flights.map((flight, tripIndex) => ({
            label: `Trip ${tripIndex + 1}`,
            seats: getTripSeats(fare, flight, tripIndex),
          }))}
          links={
            <>
              <AppLink
                linkText="Fare Rules"
                variant="secondary"
                className="fs-14"
                onClick={() => handleFareRulesClick(fare)}
              />
              {['UK', 'AI'].indexOf(
                fare.flightCarrier?.[0]?.[0]?.substring(0, 2),
              ) > -1 &&
                fare.supplierName?.toLowerCase() !== 'tbo' && (
                  <AppLink
                    linkText="Mini Fare rules"
                    variant="secondary"
                    className="fs-12"
                    onClick={() => handleShowMiniFareRules(fare)}
                  />
                )}
            </>
          }
          onBook={handleBook}
          footer={
            <>
              {fare.airFreeText?.length > 0 && (
                <div className="fs-12 green-color">
                  {fare.airFreeText[0].join(',')}
                </div>
              )}
              <AppCheckBox
                name="emailorwhatsapp"
                id={fare.nextraflightkey}
                labelText="Share via Email or WhatsApp"
                onChange={() => handleSelectForEmail(fare)}
                checked={isFareSelectedForEmail(fare)}
              />
            </>
          }
        />
      );
    }
    return (
      <div
        className={`fare-component-mobile ${
          fare.isBrandedFare ? 'branded-border' : ''
        } fare-component-watermark`}
        // onClick={() => handleFareSelection(fare)}
        data-watermark={getWaterMarkForFare()}
      >
        <div className="d-flex justify-content-between flex-column h-100">
          <div className="watermark-actions d-flex justify-content-between align-items-center">
            <AppRadioInput
              id={fare.nextraflightkey}
              name={fare.nextraflightkey}
              checked={
                fare.nextraflightkey === userSelectedFare.nextraflightkey
              }
              onChange={() => setUserSelectedFare(fare)}
              labelText={
                fare.nextraflightkey === userSelectedFare.nextraflightkey
                  ? 'Selected'
                  : 'Select'
              }
            />
          </div>
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Fare Type</span>
              <span className="fs-16 fw-600 text-capitalize fare-type-span d-flex">
                <span>{fare.faretype}</span>
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Cancellation</span>
              <span className="fare-component_value">chargeable</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Reschedule</span>
              <span className="fare-component_value">chargeable</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Meal</span>
              <span className="fare-component_value">
                {getMealForFlight(fare.faretype)}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Seat</span>
              <span className="fare-component_value">chargeable</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Check In</span>
              <span className="fare-component_value">
                {getCabinBaggage(
                  fare.flightBagWeight[0][0],
                  fare.flightBagUnit[0][0],
                )}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Cabin</span>
              <span className="fare-component_value">7kg</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Class</span>
              <span className="fare-component_value">
                {fare.bookingClass[0].join(',')}
              </span>
            </div>
            {showSupplier() && (
              <div className="d-flex justify-content-between align-items-center">
                <span className="fare-component_title">Supplier</span>
                <span className="fare-component_value">
                  {getSupplierName(fare.supplierName)}
                </span>
              </div>
            )}
            <div className="d-flex justify-content-between align-items-center mt-1">
              <span className="fare-component_value">
                {fare.refundableinfo === 'Y' ? (
                  <span className="fare_refundable">Refundable</span>
                ) : (
                  <span className="fare_non-refundable">Non Refundable</span>
                )}
              </span>
              {(() => {
                const allTripsData = flights
                  .map((flight, tripIndex) => ({
                    tripIndex,
                    tripSeats: getTripSeats(fare, flight, tripIndex),
                  }))
                  .filter(
                    (t) =>
                      t.tripSeats.length > 0 &&
                      parseInt(t.tripSeats[0], 10) > 0,
                  );

                if (allTripsData.length === 0) return null;

                const [firstTrip] = allTripsData;
                const [primarySeat] = firstTrip.tripSeats;

                return (
                  <span className="fs-12 red-color fw-600">
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip
                          id={`available-seats-tooltip-${fare.nextraflightkey}`}
                        >
                          <div className="text-start">
                            {allTripsData.length > 1 ? (
                              allTripsData.map(({ tripIndex, tripSeats }) => (
                                <div key={tripIndex}>
                                  Trip {tripIndex + 1}: {tripSeats.join(', ')}
                                </div>
                              ))
                            ) : (
                              <div>
                                Seats left:{' '}
                                {allTripsData[0]?.tripSeats.join(', ')}
                              </div>
                            )}
                          </div>
                        </Tooltip>
                      }
                    >
                      <span style={{ cursor: 'pointer' }}>
                        {getNumSeats(primarySeat)} seats left
                      </span>
                    </OverlayTrigger>
                  </span>
                );
              })()}
            </div>
          </div>
          <div>
            <div className="d-flex justify-content-between align-items-center my-2 watermark-actions">
              <div className="d-flex gap-2 align-items-center">
                <div className="d-flex flex-column">
                  <div className="fs-16 fw-600 primary-color">
                    {formatCurrency(fare.totalfq)}
                  </div>
                  {showInvoiceFare && (
                    <div className="fs-12 secondary-color">
                      {formatCurrency(fare.totalnet)}
                    </div>
                  )}
                </div>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="fare-breakup-tooltip">
                      <div className="fare-breakup">
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">Base Fare</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.totalbasefare)}
                          </div>
                        </div>
                        {/* <div className="fare-breakup_content">
                      <div className="fare-breakup_title">YQ Tax</div>
                      <div className="fare-breakup_value">
                        {formatCurrency(getYQForTheFare(fare))}
                      </div>
                    </div> */}
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">Tax</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.totaltax)}
                          </div>
                        </div>
                        {/* <div className="fare-breakup_content">
                      <div className="fare-breakup_title">K3</div>
                      <div className="fare-breakup_value">
                        {formatCurrency(getK3ForTheFare(fare))}
                      </div>
                    </div> */}
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">HC</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.handlingcharges)}
                          </div>
                        </div>
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">GST</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.servicetax)}
                          </div>
                        </div>
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">
                            Other Charges
                          </div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.transactionfee)}
                          </div>
                        </div>

                        {showInvoiceFare && (
                          <>
                            <div className="fare-breakup_content">
                              <div className="fare-breakup_title">Discount</div>
                              <div className="fare-breakup_value">
                                {formatCurrency(fare.discount)}
                              </div>
                            </div>
                            <div className="fare-breakup_content">
                              <div className="fare-breakup_title">TDS</div>
                              <div className="fare-breakup_value">
                                {formatCurrency(fare.tds)}
                              </div>
                            </div>
                            <div className="fare-breakup_content">
                              <div className="fare-breakup_title">Net Fare</div>
                              <div className="fare-breakup_value">
                                {formatCurrency(fare.totalnet)}
                              </div>
                            </div>
                          </>
                        )}
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">Total Fare</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.totalfq)}
                          </div>
                        </div>
                      </div>
                    </Tooltip>
                  }
                >
                  <div className="cursor-pointer secondary-color">
                    <MdInfo />
                  </div>
                </OverlayTrigger>
              </div>
              <div className="d-flex flex-column">
                <AppLink
                  linkText="Fare Rules"
                  variant="secondary"
                  className="fs-14"
                  onClick={() => handleFareRulesClick(fare)}
                />
                {['UK', 'AI'].indexOf(
                  fare.flightCarrier[0][0].substring(0, 2),
                ) > -1 &&
                  fare.supplierName.toLowerCase() !== 'tbo' && (
                    <AppLink
                      linkText="Mini Fare rules"
                      variant="secondary"
                      className="fs-10"
                      onClick={() => handleShowMiniFareRules(fare)}
                    />
                  )}
              </div>
            </div>
            <div className="d-flex my-1 watermark-actions">
              <AppButton
                btnText="Book now"
                variant="primary"
                className="fs-16 flex-1"
                onClick={() => handleBook(fare)}
              />
            </div>
            {fare.airFreeText.length > 0 && (
              <div className="mt-1 fs-12 green-color">
                {fare.airFreeText[0].join(',')}
              </div>
            )}
            <div className="watermark-actions">
              <AppCheckBox
                name="emailorwhatsapp"
                id={fare.nextraflightkey}
                labelText="Share via Email or WhatsApp"
                onChange={() => handleSelectForEmail(fare)}
                checked={isFareSelectedForEmail(fare)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleShowFlightDetails = () => {
    setShowFlightDetails(true);
    setSelectedTab(FLIGHT_INFO);
  };

  return (
    <>
      <section
        className={` d-flex my-2 one-way-new-result-card ${
          showFares ? 'mb-0 pb-0' : ''
        }`}
      >
        <AppLoading isLoading={isLoading} />
        {alert && (
          <AppAlert
            showIcon
            variant={alert.variant}
            title={alert.title}
            onHide={() => setAlert(undefined)}
            description={alert.description}
          />
        )}
        <div className="d-flex flight-info flex-column gap-0">
          {flights.map((flight, fltIndex) => (
            <FlightInfo
              flight={flight}
              isOnward={index === 0}
              key={flight.nextraflightkey}
              fltIndex={fltIndex}
            />
          ))}
        </div>
        <div className=" d-flex fare-info justify-content-between ">
          <div className="d-flex flex-column me-3 flex-1 text-end ">
            <span className="fs-18 fw-600 secondary-color">
              {formatCurrency(onwardFares[0].totalfq)}
            </span>
            {showInvoiceFare && (
              <div className="fs-12 secondary-color">
                {formatCurrency(onwardFares[0].totalnet)}
              </div>
            )}

            <span className="fs-10 fw-600 red-color ">
              {getNumSeats(onwardFares[0].numseatsavailable[0][0])} seats left
            </span>
          </div>
          <div className="d-flex flex-column align-items-center">
            <AppLink
              linkText={showFares ? 'Hide Fares' : 'More Fares'}
              variant="secondary"
              className="fs-14 fw-600"
              onClick={() => setShowFares((prev) => !prev)}
            />
            <AppLink
              linkText="Flight Details"
              className="fs-12 fw-600 mt-1"
              variant="primary"
              onClick={handleShowFlightDetails}
            />
          </div>
        </div>
        {isOpenFareRulesDialog && (
          <AppSidebar
            sidebarTitle="Fare Rules"
            animatedClass="slide-from-right-animation"
            onHideSidebar={() => setIsOpenFareRulesDialog(false)}
            className="overflow-auto flight-details-sidebar"
          >
            <div
              dangerouslySetInnerHTML={{ __html: fareRulesHtml }}
              style={{ overflow: 'auto' }}
              className="fare-rules-tabel"
            />
          </AppSidebar>
        )}
        {isOpenMiniFareRulesDialog && (
          <AppSidebar
            sidebarTitle="Mini Fare Rules"
            animatedClass="slide-from-right-animation"
            onHideSidebar={() => setIsOpenMiniFareRulesDialog(false)}
            className="overflow-auto flight-details-sidebar"
          >
            <table className="table-bordered w-100 fs-14 mini-fare-rules-table">
              <thead>
                <tr>
                  <th>Type</th>
                  {/* <th>Passenger Type</th> */}
                  <th>Description</th>
                  <th>Charges</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Reschedule Charges</td>
                  {/* <td>Adult</td> */}
                  <td>{miniFareRulesHtml?.reshedule[0]?.description}</td>
                  <td>{miniFareRulesHtml?.reshedule[0]?.amount}</td>
                </tr>
                <tr>
                  <td>Cancellation Charges</td>
                  {/* <td>Adult</td> */}
                  <td>{miniFareRulesHtml?.cancellation[0]?.description}</td>
                  <td>{miniFareRulesHtml?.cancellation[0]?.amount}</td>
                </tr>
              </tbody>
            </table>
          </AppSidebar>
        )}
        {showFlightDetails && (
          <AppSidebar
            sidebarTitle="Flight Details"
            animatedClass="slide-from-right-animation"
            onHideSidebar={() => setShowFlightDetails(false)}
            className="flight-details-sidebar"
          >
            <div className="flight-details_tabs">
              <div className="flight-details_tabs_container">
                <button
                  onClick={() => setSelectedTab(FLIGHT_INFO)}
                  className={`${
                    selectedTab === FLIGHT_INFO ? 'selected-tab-btn' : 'tab-btn'
                  }`}
                >
                  Flight Information
                </button>
                <button
                  onClick={() => setSelectedTab(FARE_BREAKUP)}
                  className={`${
                    selectedTab === FARE_BREAKUP
                      ? 'selected-tab-btn'
                      : 'tab-btn'
                  }`}
                >
                  Fare Breakup
                </button>
                <button
                  onClick={handleOpenFareRules}
                  className={`${
                    selectedTab === FARE_RULES ? 'selected-tab-btn' : 'tab-btn'
                  }`}
                >
                  Fare Rules
                </button>
              </div>
            </div>

            {selectedTab === FLIGHT_INFO && (
              <>
                <div className="selected-flight-details__trip-details mt-2">
                  <div className="d-flex gap-2 trip-content align-items-center">
                    <div className="sector-span">
                      {getJourneys(
                        searchRequest.originlocations,
                        searchRequest.destinationlocations,
                        searchRequest.onwarddate,
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-0 p-lg-3">
                  {flights.map((flt, fltIndex) => (
                    <React.Fragment key={fltIndex}>
                      <div className="selected-flight-details__multicity-trip-info fs-14 fw-600">
                        Trip - {fltIndex + 1}
                      </div>
                      <div className="p-0 p-lg-3">
                        <SelectedMultiCityFlightDetails
                          selectedFlight={flt}
                          selectedFare={userSelectedFare}
                          sectorIndex={fltIndex}
                        />
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              </>
            )}
            {selectedTab === FARE_BREAKUP && (
              <div className="fare-breakup mt-3">
                <div className="fare-breakup_header">
                  <div className="fare-breakup_header_title">FARE BREAKUP</div>
                  <div className="fare-breakup_header_value">AMOUNT</div>
                </div>
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">Base Fare</div>
                  <div className="fare-breakup_value">
                    {formatCurrency(userSelectedFare.totalbasefare)}
                  </div>
                </div>
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">OT Tax</div>
                  <div className="fare-breakup_value">
                    {formatCurrency(userSelectedFare.totaltax)}
                  </div>
                </div>
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">Handling charges</div>
                  <div className="fare-breakup_value">
                    {formatCurrency(userSelectedFare.handlingcharges)}
                  </div>
                </div>
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">GST</div>
                  <div className="fare-breakup_value">
                    {formatCurrency(userSelectedFare.servicetax)}
                  </div>
                </div>
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">Other Charges</div>
                  <div className="fare-breakup_value">
                    {formatCurrency(userSelectedFare.transactionfee)}
                  </div>
                </div>
                {showInvoiceFare && (
                  <>
                    <div className="fare-breakup_content">
                      <div className="fare-breakup_title">Discount</div>
                      <div className="fare-breakup_value">
                        {formatCurrency(userSelectedFare.discount)}
                      </div>
                    </div>
                    <div className="fare-breakup_content">
                      <div className="fare-breakup_title">TDS</div>
                      <div className="fare-breakup_value">
                        {formatCurrency(userSelectedFare.tds)}
                      </div>
                    </div>
                    <div className="fare-breakup_footer">
                      <div className="fare-breakup_title">Net Fare</div>
                      <div className="fare-breakup_value">
                        {formatCurrency(userSelectedFare.totalnet)}
                      </div>
                    </div>
                  </>
                )}
                <div className="fare-breakup_footer">
                  <div className="fare-breakup_title">Total Fare</div>
                  <div className="fare-breakup_value">
                    {formatCurrency(userSelectedFare.totalfq)}
                  </div>
                </div>
              </div>
            )}
            {selectedTab === FARE_RULES && (
              <div className="pt-3 mt-3">
                <div
                  dangerouslySetInnerHTML={{ __html: fareRulesHtml }}
                  style={{ overflow: 'auto' }}
                  className="fare-rules-tabel"
                />
              </div>
            )}
          </AppSidebar>
        )}
      </section>
      {showFares && (
        <div className="fare-components-list">
          {onwardFares.map((fare) => (
            <FareComponent key={fare.nextraflightkey} fare={fare} />
          ))}
        </div>
      )}
      {/* {index === 2 && (
        <div className="add-space-container my-2">
          <img
            src={
              getValueFromAppConfig('adspaceimage') || '/images/addspace.png'
            }
            alt=""
          />
        </div>
      )} */}
    </>
  );
}

IntlMultiCityResultsCard.defaultProps = {
  selectedFare: undefined,
};

IntlMultiCityResultsCard.propTypes = {
  flights: PropTypes.any.isRequired,
  onwardFares: PropTypes.array.isRequired,
  isAmPmFormat: PropTypes.bool.isRequired,
  showInvoiceFare: PropTypes.bool.isRequired,
  selectedFare: PropTypes.object,
  onFareSelection: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  searchRequest: PropTypes.object.isRequired,
  onSelectForEmail: PropTypes.func.isRequired,
  flightsForEmail: PropTypes.array.isRequired,
};

export default IntlMultiCityResultsCard;
